class Propriedade {
  "id": Number = 0;
  "descricao": String = "";
  "valorPadrao": String = "";
  "rotina": string = "";
  "complemento": string = "";
  "expressao": string = "";
  "criadoEm": Date = new Date();
  "excluidoEm": Date = new Date();
  "d_E_L_E_T_E": boolean = false;
}
export default Propriedade;

